//
//
//
//

export default {
    name: "userCoupon",
    data() {
        return {
            member: {}
        }
    },
    methods: {
        async getMyMember() {
            this.$toast.loading({
                duration: 0,
                message: ''
            });
            await this.$store.dispatch({
                type: 'member/getMyMember'
            }).then(() => {
                this.member = this.$store.state.member.memberInfo;
                localStorage.setItem('MemberId', this.member.id);
            }).finally(() => {
                this.$toast.clear();
            });
        },
    },
    created() {
        this.getMyMember()
    }
}
